export default __webpack_public_path__ + "static/media/1854.607a7e4f.png";